import React from "react";
import {
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Box,
} from "@mui/material";
import {
  Dashboard as DashboardIcon,
} from "@mui/icons-material";

const MenuList = ({ isDarkTheme, currentPath, handleMenuItemClick }) => {
  // Get menuList from localStorage
  const menuList = JSON.parse(localStorage.getItem("menuList") || "[]");

  // Color configuration for each menu
  const iconColors = {
    "MENU-001": "#3b82f6", // Blue for Dashboard
  };

  // Menu configuration with colored icons
  const menuConfig = {
    "MENU-001": {
      icon: <DashboardIcon sx={{ color: iconColors["MENU-001"] }} />,
      path: "/dashboard",
      label: "Dashboard",
    },
  };

  return (
    <List sx={{ px: 1.2, pt: 1 }}>
      {menuList
        .filter(menu => menu.permission === 'yes')
        .map((menu) => {
          const config = menuConfig[menu.menuId];
          if (!config) return null;
          const isActive = currentPath === config.path;

          return (
            <ListItem
              key={menu.menuId}
              button
              onClick={() => handleMenuItemClick(config.path)}
              sx={{
                borderRadius: 2.5,
                mb: 0.65,
                border: isActive
                  ? `1px solid ${isDarkTheme ? 'rgba(96,165,250,0.45)' : 'rgba(59,130,246,0.35)'}`
                  : `1px solid ${isDarkTheme ? 'rgba(148,163,184,0.08)' : 'rgba(226,232,240,0.6)'}`,
                background: isActive
                  ? (isDarkTheme ? 'rgba(37,99,235,0.2)' : 'rgba(59,130,246,0.1)')
                  : 'transparent',
                '&:hover': {
                  backgroundColor: isDarkTheme 
                    ? 'rgba(148,163,184,0.14)' 
                    : 'rgba(15,23,42,0.06)',
                  '& .menu-icon': {
                    backgroundColor: `${iconColors[menu.menuId]}15`,
                    borderRadius: 1,
                    p: 0.5,
                    transition: 'all 0.2s ease'
                  }
                },
              }}
            >
              <ListItemIcon
                className="menu-icon"
                sx={{
                  minWidth: 40,
                  transition: 'all 0.2s ease',
                  ...(isActive ? {
                    backgroundColor: `${iconColors[menu.menuId]}20`,
                    borderRadius: 1,
                    p: 0.5,
                  } : {}),
                  '& svg': {
                    fontSize: '1.5rem'
                  }
                }}
              >
                {config.icon}  
              </ListItemIcon>
              <ListItemText
                primary={menu.menuName}
                sx={{
                  '& .MuiListItemText-primary': {
                    fontSize: '0.95rem',
                    fontWeight: isActive ? 700 : 500,
                    color: isDarkTheme ? '#fff' : '#0f172a',
                    letterSpacing: 0.1,
                  }
                }}
              />
            </ListItem>
          );
        })}
    </List>
  );
};

export default MenuList;
